"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * An error thrown by our fetch implementation. It allows for inspection
 * of a response if present. Typically thrown when response has a status
 * code > 399 and <= 599, but could also be thrown when connectivity is
 * an issue.
 */

var FetchError =
/** @class */
function (_super) {
  __extends(FetchError, _super);

  function FetchError(status, msg, response, originalError) {
    var _this = _super.call(this, msg) || this;

    _this.status = status;
    _this.response = response;
    _this.originalError = originalError;
    return _this;
  }

  return FetchError;
}(Error);

exports.default = FetchError;